export default {
  actions: '操作',
  view: '查看',
  edit: '編輯',
  delete: '刪除',
};
